var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6011 9.39935C17.2692 9.0674 16.731 9.0674 16.3991 9.39935L12.0001 13.7983L7.60114 9.39935C7.26919 9.06741 6.731 9.06741 6.39906 9.39935C6.06711 9.7313 6.06711 10.2695 6.39906 10.6014L11.3991 15.6014C11.731 15.9334 12.2692 15.9334 12.6011 15.6014L17.6011 10.6014C17.9331 10.2695 17.9331 9.7313 17.6011 9.39935Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.7a85f6c3eed008fa72b2e6e0f85ed73f.svg";
export { ForwardRef as ReactComponent };